



















































































































































































import AfterFetchComponent from "@/components/base/AfterFetchComponent";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {GridColumn} from "@payroll/grid-widget/src/models/GridColumn";
import {KeyValuePair} from "@payroll/optimus-common";
import {FieldType, SearchFieldModel} from "@payroll/search-results-widget/src/models/SearchField.model";
import Component from "vue-class-component";
import {Action} from "vuex-class";

@Component({})
export default class EntitlementSimulatorComponent extends AfterFetchComponent {
  @Action('fetchEntitlementSimulator', StoreNamespace.ENTITLEMENT) fetchEntitlementSimulator: any
  @Action('getInnerDateStepOneEntitlementSimulator', StoreNamespace.ENTITLEMENT) getInnerDateStepOneEntitlementSimulator: any
  @Action('getLoanMonthOptions', StoreNamespace.ENTITLEMENT) getLoanMonthOptions: any
  @Action('fetchInnerDataLoans', StoreNamespace.ENTITLEMENT) fetchInnerDataLoans: any

  private columns: GridColumn[] = []
  private searchLoansFields: SearchFieldModel[] = []
  private selectedLoanType: KeyValuePair = {} as KeyValuePair
  private selectedNumberOfYears: KeyValuePair = {} as KeyValuePair
  private selectedInterestType: KeyValuePair = {} as KeyValuePair
  private finalLoanType: KeyValuePair[] = [];
  private finalNumberOfYears: KeyValuePair[] = [];
  private finalInterestType: KeyValuePair[] = [];
  private firstSelectInterestType: KeyValuePair = {} as KeyValuePair;
  private firstRefundMethod: KeyValuePair = {} as KeyValuePair;
  private selectedRow: any = null;
  private problemWithApplication: boolean = false;
  private onRowInit: boolean = false;
  private fundType: string = "";
  private memberIdNum: string = "";
  private allAccounts: any;
  private memberAccountLoansModel: any;


  mounted() {
    this.initSearchFields()
    this.fetchEntitlementSimulator({requestorCallback: this})
  }

  onSuccess(data ?: any, requestName ?: string, message ?: string, success ?: boolean): void {
    switch (requestName) {
      case 'fetchEntitlementSimulator':
        this.initColumns();
        this.bindGridData(data);
        this.allAccounts = data;
        break

      case 'getInnerDateStepOneEntitlementSimulator':
        this.initLoansDetails(data);
        this.memberAccountLoansModel = data.memberAccountLoansModel;
        this.finalInterestType = data.interestTypeOptions;
        this.firstSelectInterestType = this.finalInterestType[0]
        break

      case 'fetchInnerDataLoans':
        this.memberAccountLoansModel = data[0]
        break

      case 'getLoanMonthOptions':
        this.finalNumberOfYears = data
        break
    }
  }

  onError(messages: string[], code: number, requestName?: string): void {
    switch (requestName) {
      case 'fetchEntitlementSimulator':
        this.problemWithApplication = true;
        this.allAccounts = null
        this.bindGridData([]);
        break
      default:
        this.handleOnError(messages, code, requestName);
    }
  }

  bindGridData(data: any[]): void {
    this.$emit('successResults', {
      results: data,
      hasMore: false,
      resultCount: data.length
    });
  }

  private getGridData(searchObject: any): void {
    this.selectedRow = null;
    this.fetchEntitlementSimulator({
      requestorCallback: this,
      requestBody: searchObject
    })

    this.memberIdNum = searchObject.memberIdNum;
  }

  private onRowClick(res: any): void {
    this.selectedRow = res;
    this.onRowInit = true;
    this.fundType = res.fundType

    this.fetchNumberOfYears();
  }

  private initSearchFields(): void {
    this.searchLoansFields.push({
      label: 'entitlementSimulator.idNumber',
      property: 'memberIdNum',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 16,
      advancedOnly: false,
      bootstrapColumn: 3
    })
  }

  private initLoansDetails(data: any): void {

    const translateDescription: any = this.$t("entitlementSimulator." + data.refundMethodSelect.name);

    for (const element of data.allLoanTypesOptions) {
      const translateDescription: any = this.$t("entitlementSimulator." + element.name);
      this.finalLoanType.push({
        value: element.name,
        description: translateDescription
      })
    }

    for (const element of data.loanMonthOptions) {
      this.finalNumberOfYears.push({
        value: element.value,
        description: element.description
      })
    }

    this.firstRefundMethod = {
      value: data.refundMethodSelect.name,
      description: translateDescription
    };
  }

  private onRefundMethodChange(): void {
    if (!this.onRowInit) {
      this.fetchOnlyNumberOfYears();
    } else {
      this.onRowInit = false;
    }
  }

  private fetchOnlyNumberOfYears() {
    if (this.selectedRow != null) {
      const requestLoanMonthOptions = {
        accountNumber: this.selectedRow.accountNum,
        loanType: this.selectedLoanType.value !== undefined ? this.selectedLoanType.value : this.firstRefundMethod.value,
        fundType: this.fundType,
        processTypeCode: 'LOAN_PROCESS',
        interestType: this.selectedInterestType.value
      }

      this.getLoanMonthOptions({requestBody: requestLoanMonthOptions, requestorCallback: this})
      this.finalNumberOfYears = [];
    }
  }

  private closePopupProblem(): void {
    this.problemWithApplication = false;
  }

  initColumns(): void {
    this.columns.push({
      property: 'accountNum',
      header: 'entitlementSimulator.accountNumber',
      hideSorting: false
    } as GridColumn);
    this.columns.push({
      property: 'employerName',
      header: 'entitlementSimulator.employerName',
      hideSorting: false
    } as GridColumn);
    this.columns.push({
      property: 'liquidDate',
      header: 'entitlementSimulator.liquidDate',
      hideSorting: false
    } as GridColumn);
    this.columns.push({
      property: 'accountBalance',
      header: 'entitlementSimulator.accountBalance',
      hideSorting: false
    } as GridColumn);
  }

  private fetchNumberOfYears() {
    const defaultAccount = this.allAccounts[0].accountNum;

    const requestLoanMonthOptions = {
      accountNumber: this.selectedRow != null ? this.selectedRow.accountNum : defaultAccount,
      loanType: this.selectedLoanType.value !== undefined ? this.selectedLoanType.value : this.firstRefundMethod.value,
      fundType: this.fundType,
      processTypeCode: 'LOAN_PROCESS'
    }

    this.getInnerDateStepOneEntitlementSimulator({
      requestBody: requestLoanMonthOptions, pathVariable: this.memberIdNum
      , requestorCallback: this
    })

    this.finalNumberOfYears = [];
    this.finalLoanType = []
  }

}
